export default {"src":"https://cdn.jetlend.ru/_next/static/media/bks-icon.95468a93.svg","height":26,"width":25,"blurWidth":0,"blurHeight":0};